import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Enums } from '../../shared/enums';
import { IMPORTS } from './_imports';

@Component({
    selector: 'landing-page',
    templateUrl: './landing-page.component.html',
    styleUrl: './landing-page.component.scss',
    standalone: true,
    imports: IMPORTS
})
export class LandingPageComponent implements OnInit {
    // #region [Type props]
    Enums = Enums;
    // #endregion

    // #region [props]
    showEdoquinho = false;
    // #endregion

    constructor(private route: ActivatedRoute) {
        this.showEdoquinho = this.route.snapshot.queryParams.e != null;
    }

    ngOnInit() { }

    // #region [===== private methods =====]
    // #endregion
}
